import { trackEvent } from '../../../utils/tracking';

interface LinkButtonProps {
  text: string;
  url: string;
  textSize?: string;
  bgColor?: string;
  textColor?: string;
  className?: string;
  widthClass?: string;
  openInNewTab?: boolean; 
}

const LinkButton: React.FC<LinkButtonProps> = ({
  text,
  url,
  textSize = '16px',
  bgColor = 'black',
  textColor = 'white',
  className = '',
  widthClass = 'w-72', 
  openInNewTab = false,
}) => {
  return (
    <a
      href={url}
      target={openInNewTab ? '_blank' : '_self'}
      rel={openInNewTab ? 'noopener noreferrer' : undefined}
      onClick={() => {
        if (url?.includes('sok-aterforsaljare-verkstad')) {
          trackEvent({ event: 'find_a_dealer', model: undefined });
        }
      }}
      className={`${widthClass} bg-black hover:underline no-underline underline-offset-2 text-white  px-2 py-3 flex items-center justify-center ${className}`}
      style={{
        fontSize: textSize,
        backgroundColor: bgColor,
        color: textColor,
      }}
    >
      {text}
    </a>
  );
};

export default LinkButton;

